import {Component, OnInit} from '@angular/core';
import {AbstractDataProvider} from '../AbstractDataProvider';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AuthServiceCustom} from 'src/shared/service/auth.service';
import {AssociateAccount, MyProfileModel} from 'src/shared/model/UserProfile';
import {DynamicModalService} from '../ui-components/dynamic-modals/dynamic-modal.service';
import {EnUserTypes} from '../security/page-name.enum';
import {ActivatedRoute} from '@angular/router';
import {DictionaryService} from '../../shared/service/dictionary.service';
import {finalize} from 'rxjs/operators';
import {getErrorMessageText} from '../helper';

interface LinkedAccount {
  EmailAddress: string;
  Name: string;
  Phone: string;
  RecordNum: number;
  RecordType: string;
  SeqNum: number;
  WpUserNum: number;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})


export class ProfileComponent implements OnInit {
  display = false;
  heightOfGridContainer = 0;

  userProfileEntity: MyProfileModel = new MyProfileModel();
  displayConfirmationPopup = false;
  alertMessage: string;
  userId: string;
  changePasswordUrl = 'changepassword';
  updateAddressUrl = 'changeaddress';
  updateProfileUrl = 'editprofile';
  updateActivateUserUrl = 'activate-user';
  updateActivationStateUrl = 'change-activation-state';
  linkAccount = 'link-account';
  addNewLoginPopup = 'add-new-login-popup';
  userInfoConfigurationUserTypeWise: any = {};
  userType: string;
  linkAccounts: Array<LinkedAccount> = [];
  listOtherLogins: Array<AssociateAccount> = [];
  isCurrentUserProfile: boolean;
  ownershipTitle: string;
  accountOwnershipTitle: string;
  originalUser_userType: string;
  confirmationCallback: (result) => void;

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    public authService: AuthServiceCustom,
    private ngxService: NgxUiLoaderService,
    private dynamicModalService: DynamicModalService,
    private route: ActivatedRoute,
    private dictionaryService: DictionaryService
  ) {
  }

  ngOnInit() {
    this.heightOfGridContainer = this.authService.heightOfPageContainer - 14;
    this.isCurrentUserProfile = this.route.snapshot.data.currentUserProfile || !this.authService.PreviousLoggedInUser;
    this.userType = this.authService.UserType;
    this.originalUser_userType = this.authService.originalUser && this.authService.originalUser.UserType;

    this.getUserRelatedData();
    this.getTextAndVisibilityConfiguration();
    this.ownershipTitle = this.isCurrentUserProfile
      ? 'My User'
      : this.getUserTypeTitle(this.authService.UserType);

    this.accountOwnershipTitle = this.isCurrentUserProfile
      ? 'My'
      : this.getUserTypeTitle(this.userType);
  }

  getUserRelatedData() {
    let url = 'api/Accounts/GetMyUserProfileInfo';
    this.ngxService.start();
    url = this.isCurrentUserProfile ? this.abstractDataProvider.appendCurrentUserInfo(url) : url;
    this.abstractDataProvider.getData(url, !this.isCurrentUserProfile).pipe(finalize(() => this.ngxService.stop())).subscribe(
      posts => {
        this.userProfileEntity = posts.Data;
        this.userId = this.userProfileEntity.UserId;
        if (this.userType == "I" && this.authService.PreviousLoggedInUser?.UserType == "D" && this.authService.PreviousLoggedInUser?.UserClass == "1" && this.userId) {
          this.userId = "XXXXXXXXXX";
        }

        this.listOtherLogins = this.userProfileEntity.ListOtherLogins;
        this.linkAccounts = this.userProfileEntity.ListLinkAccounts;
        this.linkAccounts.forEach(account => account.RecordType = this.ClientTypeToText(account.RecordType));

        this.authService.currentUserProfileEntity = posts.Data;

        if (this.userType == EnUserTypes.Investor) {
          // Check CurrAddress Beg and End Date, if they are 0101 to 1231 respectively, then don't show legal address, as per Keith's Mail 28Aug2019
          if (this.userProfileEntity.CurrAddressBegMonthDay == '0101' && this.userProfileEntity.CurrAddressEndMonthDay == '1231') {
            this.userInfoConfigurationUserTypeWise.myAccountInfo.legalAddressDisp = false;
          }
        }
        if (this.userType == EnUserTypes.User && this.userProfileEntity.WebportalOnlyFlag == 'Y') {
          this.userInfoConfigurationUserTypeWise.changePasswordDisp = true;
        }
        if (this.authService.originalUser.UserType == EnUserTypes.User) {
          this.userInfoConfigurationUserTypeWise.requestAddressChangeDisp = false;
        }

      },
      error => {
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      }
    );
  }


  getTextAndVisibilityConfiguration() {
    const userType = (this.isCurrentUserProfile
      ? this.authService.originalUser
      : this.authService).UserType;

    this.userInfoConfigurationUserTypeWise = this.authService.getTextAndVisiblityConfiguration(userType);
  }

  changePassword() {
    this.dynamicModalService.modal(this.changePasswordUrl, null, '500px', 'auto').subscribe((val: any) => {
    });
  }

  updateAddress() {
    this.dynamicModalService.modal(this.updateAddressUrl, null, '860px', 'auto').subscribe((val: any) => {
      this.getUserRelatedData();
    });
  }

  changeActivationStatus(status: string) {
    switch (status) {
      case 'activate':
        this.dynamicModalService.modal(this.updateActivateUserUrl, null, '800px', 'auto').subscribe((result: any) => {
          if (result) {
            this.getUserRelatedData();
          }
        });
        break;
      case 'deactivate':
        this.dynamicModalService.modal(this.updateActivationStateUrl, null, '400px', 'auto').subscribe((result: any) => {
          if (result) {
            this.getUserRelatedData();
          }
        });
        break;
      case 'reactivate':
        const message = 'Reactivate account?';
        this.showConfirmationPopup(message, (ok) => {
          if (ok) {
            this.reactivateUser();
          }
        });
        break;
    }
  }

  updateProfile() {
    this.dynamicModalService.modal(this.updateProfileUrl, null, '800px', 'auto').subscribe((result: any) => {
      if (result) {
        this.getUserRelatedData();
      }
    });
  }

  urlInNewTab(objectToExtractInfoFrom: any) {
    const url = 'home';
    this.authService.navigateUrlInNewTab(url, objectToExtractInfoFrom);
  }

  askConfirmation(item: LinkedAccount): void {
    const message = `Remove ${item.Name} accounts?`;
    this.showConfirmationPopup(message, (ok) => {
      if (ok) {
        this.deleteLinkedAccount(item);
      }
    });
  }

  askConfirmationOfAccountAccessRemoval(item: AssociateAccount): void {
    const message = `Remove ${item.Name} account?`;
    this.showConfirmationPopup(message, (ok) => {
      if (ok) {
        this.deleteOtherLogin(item);
      }
    });

  }

  private showConfirmationPopup(message: string, callback: (ok) => void) {
    this.confirmationCallback = callback;
    this.alertMessage = message; // TODO: move to dictionary
    this.displayConfirmationPopup = true;
  }

  onConfirm(ok: boolean): void {
    this.displayConfirmationPopup = false;
    this.confirmationCallback(ok);
  }

  deleteOtherLogin(itemToDelete: AssociateAccount): void {
    this.ngxService.start();
    // TODO: replace with real url
    const url = ``;
    // api/Accounts/DeleteLinkedAccount?UnlinkSeqNum=${itemToDelete.SeqNum}&UnlinkWpUserNum=${itemToDelete.WpUserNum}
    this.abstractDataProvider.postData({}, url)
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe(() => {
        this.display = true;
        this.alertMessage = 'Deleted.';
        this.getUserRelatedData();
      }, error => {
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      });
  }

  deleteLinkedAccount(itemToDelete) {
    this.ngxService.start();
    this.abstractDataProvider.postData({}, `api/Accounts/DeleteLinkedAccount?UnlinkSeqNum=${itemToDelete.SeqNum}&UnlinkWpUserNum=${itemToDelete.WpUserNum}`)
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe(() => {
        this.display = true;
        this.alertMessage = 'Deleted.';
        this.getUserRelatedData();
      }, error => {
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      });
  }

  reactivateUser() {
    this.abstractDataProvider.postData(this.userProfileEntity, 'api/Accounts/ReactivateUser').subscribe(
      (posts: any) => {
        this.userProfileEntity.DeactivatedDate = null;
        this.display = true;
        this.alertMessage = posts.Data.AlertMsgs[0];
      },
      error => {
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      }
    );
  }

  showAddNewLoginPopup(): void {
    this.dynamicModalService.modal(this.addNewLoginPopup, null, '600', 'auto').subscribe((result: any) => {
      if (result) {
        this.getUserRelatedData();
      }
    });
  }

  showLinkAccountPopup(): void {
    this.dynamicModalService.modal(this.linkAccount, null, '500px', 'auto').subscribe((result: any) => {
      if (result) {
        this.getUserRelatedData();
      }
    });
  }

  ClientTypeToText(code: string): string {
    if (code === 'I') {
      return this.dictionaryService.localize('INVESTOR');
    }
    if (code === 'B') {
      return this.dictionaryService.localize('BROKER');
    }
    if (code === 'T') {
      return this.dictionaryService.localize('CUSTODIAN');
    }
    if (code === 'R') {
      return this.dictionaryService.localize('REP');
    }
    if (code === 'Y') {
      return this.dictionaryService.localize('TERRITORY');
    }
    if (code === 'U') {
      return this.dictionaryService.localize('USER');
    }
    if (code === 'D') {
      return this.dictionaryService.localize('DUPMAIL');
    }
  }

  getUserTypeTitle(userType: string): string {
    switch (userType) {
      case EnUserTypes.Investor:
        return this.dictionaryService.localize('INVESTOR');
      case EnUserTypes.Broker:
        return this.dictionaryService.localize('BROKER');
      case EnUserTypes.Custodian:
        return this.dictionaryService.localize('CUSTODIAN');
      case EnUserTypes.Rep:
        return this.dictionaryService.localize('REP');
      case EnUserTypes.Territory:
        return this.dictionaryService.localize('TERRITORY');
      case EnUserTypes.User:
        return this.dictionaryService.localize('USER');
      case EnUserTypes.DupMail:
        return this.dictionaryService.localize('DUPMAIL');
    }
  }
}
